import { Component } from '@angular/core';

import { BaseIconComponent } from '../base-icon.component';

@Component({
  selector: 'app-business-construction-warranty-insurance-icon',
  template: `
    <svg
      [attr.width]="width"
      [attr.height]="height"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_522_2468)">
        <path
          d="M8.25 19.5H5.25C4.85218 19.5 4.47064 19.342 4.18934 19.0607C3.90804 18.7794 3.75 18.3978 3.75 18V10.5"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M0.75 9L9.531 1.57C9.80185 1.34079 10.1452 1.21501 10.5 1.21501C10.8548 1.21501 11.1982 1.34079 11.469 1.57L18.753 7.734"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M15.75 1.5H18.75V4.5"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M17.25 22.5C20.5637 22.5 23.25 19.8137 23.25 16.5C23.25 13.1863 20.5637 10.5 17.25 10.5C13.9363 10.5 11.25 13.1863 11.25 16.5C11.25 19.8137 13.9363 22.5 17.25 22.5Z"
          stroke="#00D5D3"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M19.924 14.755L17.019 18.629C16.9544 18.7149 16.8721 18.786 16.7777 18.8373C16.6833 18.8887 16.579 18.9192 16.4717 18.9268C16.3645 18.9344 16.2569 18.9189 16.1562 18.8813C16.0555 18.8437 15.964 18.785 15.888 18.709L14.388 17.209"
          stroke="#00D5D3"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_522_2468">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  `,
})
export class BusinessConstructionWarrantyInsuranceIconComponent extends BaseIconComponent {}
